import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useClient } from '../contexts/ClientContext';
import Login from './Login';
import ClientSelector from './ClientSelector';
import LanguageInitializer from './LanguageInitializer';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { currentUser, userData } = useAuth();
  const { selectedClient, isLoadingClients, isInAdminMode } = useClient();
  
  if (!currentUser) {
    return <Login />;
  }

  // Wrap all authenticated content with LanguageInitializer
  return (
    <LanguageInitializer>
      {/* SuperAdmin and Admin users need to select a client, unless they're in admin mode */}
      {(userData?.user_type === 'superadmin' || userData?.user_type === 'admin') && !selectedClient && !isInAdminMode ? (
        // If still loading, show a spinner
        isLoadingClients ? (
          <div className="min-h-screen flex items-center justify-center bg-gray-50">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        ) : (
          // Otherwise show client selector
          <ClientSelector />
        )
      ) : userData?.user_type === 'user' && !selectedClient ? (
        // For regular users with assigned client
        userData.assigned_clients && userData.assigned_clients.length > 0 ? (
          // This should be handled in a useEffect to avoid render issues
          <ClientSelector />
        ) : (
          // Otherwise use the default database configuration
          <>{children}</>
        )
      ) : (
        <>{children}</>
      )}
    </LanguageInitializer>
  );
};

export default ProtectedRoute; 